module.exports = __webpack_public_path__ + "static/media/icons8-whatsapp.7b6eb823.svg";